import { WarningFilled } from '@ant-design/icons';
import { List, Popover, Tag } from 'antd';
import { type ReactNode } from 'react';

import styles from './NodeUi.module.scss';

export default function ErrorRender({ errorMessages }: { errorMessages: ReactNode[] }) {
  return (
    <Popover
      content={(
        <List
          size="small"
          dataSource={errorMessages}
          renderItem={(item) => <List.Item>{item}</List.Item>}
          split={false}
        />
      )}
      overlayInnerStyle={{ padding: 0 }}
      placement="left"
    >
      <Tag
        color="red"
        className={styles.errorTag}
        icon={<WarningFilled />}
      >
        Errors Found
      </Tag>
    </Popover>
  );
}
